import { euroFormat } from "@jog/shared";
export const Money = ({ centAmount }) => {
    return <>{transMoney(centAmount)}</>;
};
export const transMoney = (cent, EUR = true) => {
    if (cent < 0) {
        return `-${transMoney(cent * -1)}`;
    }
    const euro = cent < 100 ? 0 : Math.floor(cent / 100);
    const cents = Math.round(cent % 100);
    const format = (t) => (EUR ? euroFormat(t) : t);
    if (process.env.NEXT_PUBLIC_COUNTRY === "FR") {
        if (cents === 0)
            return format(`${euro},00`);
        if (cents < 10)
            return format(`${euro},0${cents}`);
        return format(`${euro},${cents}`);
    }
    if (cents === 0)
        return format(`${euro}.-`);
    if (cents < 10)
        return format(`${euro}.0${cents}`);
    return format(`${euro}.${cents}`);
};
